import { useState } from 'react'
import { Button } from 'src/modules/core/components'
import classes from './delete-template.module.scss'

interface DeleteTemplateProps {
  onDelete: () => void
  isDeleting?: boolean
}

export function DeleteTemplate({ onDelete, isDeleting }: DeleteTemplateProps) {
  const [showConfirm, setShowConfirm] = useState(false)

  return (
    <div className={classes.dangerSection}>
      <div className={classes.dangerContent}>
        <h3 className={classes.dangerTitle}>Delete message template</h3>
        <p className={classes.dangerMessage}>
          This cannot be undone. Any reminders using this template will use the <strong>default template</strong>{' '}
          instead.
        </p>
        {showConfirm ? (
          <div className={classes.confirmActions}>
            <Button variant="secondary" onClick={() => setShowConfirm(false)}>
              Don&apos;t delete
            </Button>
            <Button variant="danger" onClick={onDelete} disabled={isDeleting}>
              {isDeleting ? 'Deleting...' : 'Confirm'}
            </Button>
          </div>
        ) : (
          <Button variant="danger-outline" onClick={() => setShowConfirm(true)}>
            Delete
          </Button>
        )}
      </div>
    </div>
  )
}
